import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  loggMeIN,
  rmAuth,
  toggleMenu,
} from "../../redux/Functions/actions";
import {
  MenuButton,
  PageStyle,
  PageTitleStyle,
  TableResponsive,
  TableBody,
  TableHead,
  TableRowHead,
  TableRowBody,
  PageContainer,
  Table,
  TableHeadStyle,
  TableBodyStyle,
  EyeIcon,
  Pagination
} from "../../styles/MainLayout";

import Search from "../search/search";
import EcommerceModal from "./eCommerceModal";
import { Link } from "react-router-dom";
import axios from "../../axios"
import ReactPaginate from "react-paginate";
import ECommerceEditVariations from "./eCommerceEditVariations";

const ECommerce = (props) => {

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenVariation, setIsOpenVariation] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [dataToModal, setDataToModal] = useState();
  const [editVariationsDataToModal, setEditVariationsDataToModal] = useState();
  const [ecomItems, setEComItems] = useState();
  const [ecomItemCat, setEComItemCat] = useState();
  const [ecomItemID, setEComItemID] = useState();

  const [filtered, setFiltered] = useState([]);

  //Pagination

  const [pageNumber, setPageNumber] = useState(0);
  const itemsPerPage = 8;
  const pagesVisited = pageNumber * itemsPerPage;
  const pageCount = Math.ceil(filtered.length / itemsPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  }

  // console.log("propsat", props)

  const getECommerceItems = () => {
    axios.get('/ecommerce/all').then(data => {
      setEComItems(data.data);
      setFiltered(data?.data)
    }).catch(err => {
      console.log('ecommerceItemsErr', err);
    })
  }

  console.log("ecommerceItems", ecomItems);

  const getECommerceItemCat = () => {
    axios.get('eCom-product-cat/all').then(data => {
      console.log('catdatadata diqka', data)
      setEComItemCat(data.data);
    }).catch(err => {
      console.log('ecommerceItemsCatErr', err);
    })
  }

  console.log("ecommerceItemCat", ecomItemCat);

  useEffect(() => {
    console.log("ecomItems:", ecomItems);
    console.log("filtered:", filtered);
    getECommerceItems();
    getECommerceItemCat();
  }, []);


  const handleModalAdd = () => {
    setModalType('add')
    setIsOpen(true);
  };

  const handleModalEdit = (data) => {
    setDataToModal(data)
    setEComItemID(data)
    setModalType('edit')
    setIsOpen(true);
  };
  
  const handleModalEditVariations = (data) => {
    setEditVariationsDataToModal(data)
    // setModalType('edit')
    setIsOpenVariation(true);
  };

  const handleMenuClick = (e) => {
    e.prevenTableHeadStyleefault();
    props.toggleMenu();
  };

  return (

    <>
      {isOpen === true ?
        <EcommerceModal dataToModal={dataToModal} item={ecomItemID}
          isOpen={isOpen} type={modalType} getData={() => getECommerceItems()} handleModalClose={()=>{setIsOpen(); setDataToModal(null)}} />
        : ""
      }
      {isOpenVariation === true ?
        <ECommerceEditVariations 
        
          isOpen={isOpenVariation} getData={() => getECommerceItems()}  dataToModal={editVariationsDataToModal} handleModalClose={()=>{setIsOpenVariation();setEditVariationsDataToModal(null)}} />
        : ""
      }

      <PageStyle isMenuOpen={props?.menu}>

        <PageTitleStyle>List of e-Commerce Items</PageTitleStyle>

        <Search data={ecomItems} filtered={setFiltered} setPageNumber={setPageNumber} />

        <MenuButton onClick={handleMenuClick}>{props.menu ? <i className="fa fa-chevron-left"></i> : <i className="fa fa-bars"></i>}</MenuButton>

        <PageContainer>

          <TableResponsive isMenuOpen={props?.menu}>

            <Link to={"/eCommerce-orders"}>
              <button className="btn btn-dark mx-2 my-2">Orders</button>
            </Link>

            <Table>
              <TableHead>
                <TableRowHead>
                  <TableHeadStyle tableFirstElement>ID</TableHeadStyle>
                  <TableHeadStyle >Emri i Produktit</TableHeadStyle>
                  <TableHeadStyle >Product Name</TableHeadStyle>
                  <TableHeadStyle>Category</TableHeadStyle>
                  <TableHeadStyle>Actions</TableHeadStyle>
                </TableRowHead>
              </TableHead>
              <TableBody>
              {filtered && filtered?.length === 0 && <div className='text-secondary text  m-3'><h6>Nuk ka të dhëna</h6></div>}
                {filtered && filtered?.length > 0 && <>
                  {filtered?.slice(pagesVisited, pagesVisited + itemsPerPage)?.map((el, index) => {
                    return (
                      <>
                        <TableRowBody key={index}>
                          <TableBodyStyle tableFirstElement>{el?.id}</TableBodyStyle>
                          <TableBodyStyle >{el?.title_al}</TableBodyStyle>
                          <TableBodyStyle >{el?.title_en}</TableBodyStyle>
                          <TableBodyStyle>{ecomItemCat?.find(elem => elem?.id == el?.category)?.name_al || 'Category not found'}</TableBodyStyle>
                          <TableBodyStyle>
                            <EyeIcon onClick={() => handleModalEdit(el)} />
                            {el?.has_variants ?
                            <i className="fa fa-eye ms-3 text-success" onClick={() => handleModalEditVariations(el)} />
                            : ""}
                             </TableBodyStyle>
                        </TableRowBody>
                      </>
                    )
                  })}</>
                }

                {/* {
                  ecomItems?.map(el => {
                    return (
                      <>
                        <TableRowBody>
                          <TableBodyStyle tableFirstElement>{el?.id}</TableBodyStyle>
                          <TableBodyStyle >{el?.title_al}</TableBodyStyle>
                          <TableBodyStyle >{el?.title_en}</TableBodyStyle>
                          <TableBodyStyle>{ecomItemCat?.find(elem => elem?.id == el?.category)?.name_al || 'Category not found'}</TableBodyStyle>
                          <TableBodyStyle><EyeIcon onClick={() => handleModalEdit(el)} /> </TableBodyStyle>
                        </TableRowBody>
                      </>
                    )
                  })
                } */}
              </TableBody>
            </Table>
            <Pagination>
              <div className="text-right">
                {((ecomItems?.length >= itemsPerPage) ?
                  <ReactPaginate
                    previousLabel={<i className='fa fa-angle-double-left' />}
                    nextLabel={<i className='fa fa-angle-double-right' />}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={"paginationBttns"}
                    previousLinkClassName={"previousBttn"}
                    nextLinkClassName={"nextBttn"}
                    disabledClassName={"paginationDisabled"}
                    activeClassName={"paginationActive"}
                  /> : ''
                )}
              </div>
            </Pagination>
          </TableResponsive>
        </PageContainer>
      </PageStyle>

      <MenuButton add onClick={() => { handleModalAdd(); }}>

        <i className="fa fa-plus" />
      </MenuButton>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    lang: state.data.lang,
    langData: state.data.langData,
    isLoading: state.data.isLoading,
    loggedIn: state.data.loggedIn,
    menu: state.data.menu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loggMeIN: () => dispatch(loggMeIN()),
    rmAuth: () => dispatch(rmAuth()),
    toggleMenu: () => dispatch(toggleMenu()),
    // loadingOff: () => dispatch(loadingOff()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ECommerce);
